import EventBus from '../../../utils/EventBus';

const evbus = new EventBus();

export default evbus;
